/**
 * @author wuTao
 * @description 讲师NEV认证详情页面配置
 * @Date  2022/05/05
 */
import React from "react";
import {connect} from "dva";
import {reduxTemplateCofig, templateConfig} from "./config";

import {component_tool, framework_tool, utils_tool} from '@/tool';
import {lectureNevAuthDetailExcelColumns} from '../nevRemoteAuthDetail/excelColumns'
import moment from "moment";

let {WizContainer, WizReduxTemplate, WizInputNumber} = framework_tool;
let {WizBrowserExport} = component_tool;
let {Session, Storage} = utils_tool;
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY.MM.DD') : '';
}
const formatterDateTime = (val) => {
  return val ? moment(val).format('YYYYMMDDHHmm') : '';
}
const formatterTime = (val) => {
  return val ? moment(val).format('HH:mm:ss') : '';
}

const getUserInfo = () => {
  let user = Storage.getStorage('user') || {}
  return user
}

class LectureNevAuthDetailList extends WizContainer {
  componentName = 'lectureNevAuthDetailList';

  constructor(props) {
    super(props);
    this.state = {
      AddTimestamp: new Date().getTime()
    }
    this.currentLoginUser = getUserInfo();
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = lectureNevAuthDetailExcelColumns;
    if (o['success']) {
      let data = o['data']
      let _data = []
      data && data.forEach(d => {
        const {startDate, endDate, authDate} = d;
        let _d = {...d}
        let authTimeStr = '';
        if (startDate != null && startDate != '' && endDate != null && endDate != '') {
          authTimeStr = formatterTime(startDate) + ' ~ ' + formatterTime(endDate);
        }
        let authDateStr = '';
        if (authDate != null && authDate != '') {
          authDateStr = formatterDate(authDate);
        }
        _d.authTimeStr = authTimeStr;
        _d.authDateStr = authDateStr;
        if ((!_d.score && _d.score != 0) || _d.score < 0) {
          _d.score = "";
        }
        _data.push(_d)
      });
      let dateTime = formatterDateTime(new Date());
      WizBrowserExport({
        title: 'NEV认证详情信息',
        sheetName: 'NEV认证详情信息',
        columns: columnDefs.filter((_, index) => index),
        rows: _data,
        filename: 'NEV认证详情信息-' + dateTime + '.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let {personId} = this.currentLoginUser;
    let _templateConfig = templateConfig({self: this});
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: _templateConfig,
      apiDataFormat: {
        export: this._handleFile
      },
      currentLoginUserPersonId: personId,
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(LectureNevAuthDetailList);
